import { DSMenuItem } from 'shared-definitions/types'
import { nullableString } from 'shared-code/conversion'
import { ApiMenuItemProps } from 'data-source/types.wp'

export function menuItemMapper(input: ApiMenuItemProps): DSMenuItem {
  return {
    title: input.title,
    url: nullableString(input.url),
  }
}
